import { FastFilters } from '../fast_filters';
import { appendPreloader } from '../preloader';

export function init(fastFilters: FastFilters) {
  const container = document.querySelector('[data-mark=geoSuggest]');

  if (!container) {
    return () => [];
  }

  const inputs = container.querySelectorAll('input');

  if (inputs.length !== 1) {
    return () => [];
  }

  const input = inputs[0];
  let removeLoader: (() => void) | undefined;

  const focusListener = () => {
    fastFilters.setGeoSuggestFocus(true);
  };
  const blurListener = () => {
    fastFilters.setGeoSuggestFocus(false);
  };
  const inputListener = () => {
    if (removeLoader) {
      removeLoader();
    }
    removeLoader = appendPreloader(input.parentElement as HTMLElement, {
      size: 15,
      style: 'position:absolute;margin-left:-23px;margin-top:6px;',
    });
    fastFilters.setGeoSuggestValue(input.value);
  };

  input.addEventListener('focus', focusListener);
  input.addEventListener('blur', blurListener);
  input.addEventListener('input', inputListener);

  return () => {
    input.removeEventListener('focus', focusListener);
    input.removeEventListener('blur', blurListener);
    input.removeEventListener('input', inputListener);
  };
}
